import { BookingInfoProperties } from "./BookingPassengerTicketIssuanceProperties";

export class PostAncillaryGetProperties {
  bookingObj: BookingInfoProperties;
  error: string = "";
  isMealAvailable: boolean = false;
  isSeatAvailable: boolean = false;
  isBaggageAvailable: boolean = false;
}
